<template>
  <div class="search-examples">
    <x-body-text class="search-examples__header">Search examples</x-body-text>
    <ul role="listbox" class="search-examples__list">
      <!-- eslint-disable-next-line vuejs-accessibility/role-has-required-aria-props -->
      <li
        v-for="example in searchExamples"
        :key="example"
        role="option"
        class="search-examples__list__item"
        tabIndex="0"
        data-test="search-example"
        @click.stop="$emit('search-example-selected', example)"
        @keyup.enter="$emit('search-example-selected', example)"
      >
        <x-subtitle size="3">
          {{ example }}
        </x-subtitle>
      </li>
    </ul>
  </div>
</template>

<script setup lang="ts">
import { searchExamples } from '@/services/search-service'

import xBodyText from '@/components/shared/x-body-text/index.vue'
import xSubtitle from '@/components/shared/x-subtitle/index.vue'

defineEmits(['search-example-selected'])
</script>

<style lang="scss" scoped>
$spacing-20: 20px;
.search-examples {
  &__header {
    margin-top: $spacing-20;
    color: var(--ys-color-text-dim);
    padding-left: $spacing-20;
  }

  &__list {
    &__item {
      cursor: pointer;
      padding: $spacing-20;

      &:hover,
      &:focus {
        background-color: var(--ys-color-background-secondary);
        outline: none;
      }
    }
  }
}
</style>
